import React, { useState, useEffect } from "react";
import Modal from "../ui/Modal";

interface PromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (value: string) => void;
  title: string;
  message?: string;
  placeholder?: string;
  defaultValue?: string;
  confirmText?: string;
  cancelText?: string;
  multiline?: boolean;
  isLoading?: boolean;
}

export default function PromptModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  placeholder = "",
  defaultValue = "",
  confirmText = "Kaydet",
  cancelText = "İptal",
  multiline = false,
  isLoading = false,
}: PromptModalProps) {
  const [value, setValue] = useState<string>(defaultValue);

  useEffect(() => {
    if (isOpen) setValue(defaultValue || "");
  }, [isOpen, defaultValue]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="md">
      <div className="space-y-4">
        {message && <p className="text-gray-700 break-words">{message}</p>}

        <div>
          {multiline ? (
            <textarea
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 resize-y min-h-[120px]"
              placeholder={placeholder}
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          ) : (
            <input
              type="text"
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder={placeholder}
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          )}
        </div>

        <div className="flex gap-3 justify-end pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm">
            {cancelText}
          </button>
          <button
            onClick={() => onConfirm(value)}
            disabled={isLoading}
            className="px-4 py-2 rounded-md font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed bg-purple-600 text-white hover:bg-purple-700">
            {isLoading ? "İşleniyor..." : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
